export default __webpack_public_path__ + "static/media/BFSSInfo.ef247f84.md";